import { render, staticRenderFns } from "./CutoffPeriodDetail.vue?vue&type=template&id=4260bcb0"
import script from "./CutoffPeriodDetail.vue?vue&type=script&lang=js"
export * from "./CutoffPeriodDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports